<template>
  <div class="form-genre">
    <el-dialog v-model="dialog" @close="handleClose" :close-on-click-modal="false">
      <div class="title">
        <span>{{ $t('profits.title_select_genre') }}</span><br>
      </div>
      <el-row class="flex-no-wrap">
        <div class="el-col sidebar">
          <div
            class="region"
            v-for="(category, index) in genreCategories"
            :key="category.id"
            :class="index == genreCategories.length - 1 ? 'border-bottom' : '' "
            @click="selectCategory(index)"
          >
            <el-row :class="categorySelect == category.id ? 'selected' : ''">
              <div class="el-col" :class="categorySelect == category.id ? 'tab' : ''"></div>
              <div class="el-col" :class="categorySelect == category.id ? 'label-selected' : 'label'"><span>{{ category.name }}</span></div>
            </el-row>
          </div>
        </div>
        <div class="el-col prefecture">
          <div class="select-all">
            <el-checkbox :label="checkAll" @change="handleCheckAll" v-model="checkAll">
              {{ category.name }}  ({{ $t('all') }})
            </el-checkbox>
          </div>
          <div class="prefecture-item">
            <el-checkbox-group class="checkbox-search" v-model="tmpSelected" @change="handleSelect">
              <el-checkbox :label="item.id" :key="item.id" v-for="item in genres">
                {{ item.name }}
              </el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
      </el-row>
      <div class="list-selected">
        <span>{{ $t('profits.select_genre.selected_genre') }}：</span><br>
        <label v-for="category in Object.keys(textGenreSelected)" :key="category">
          <span v-if="textGenreSelected[category]"><span>{{ category }}：({{ textGenreSelected[category] }})</span><br></span>
        </label>
      </div>
      <div class="hint">
        <span class="label">{{ $t('profits.select_genre.hint_result') }}：</span>
        <span class="result" v-if="quantityHint > 0"> {{ quantityHint }} </span>
        <span class="ken">{{ $t('profits.select_genre.ken') }}</span>
      </div>
      <div class="footer">
        <el-button type="primary" @click="search" class="btn btn-search">{{ $t('profits.select_genre.btn_search') }}</el-button>
        <el-button type="primary" @click="clear" class="btn btn-clear-select">{{ $t('profits.select_genre.btn_clear') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { getGenres, countFromGenre, getListGenreByIds } from '../../api/genre'

  export default {
    props: {
      openDialogSelectGenre: { type: Boolean, required: true, default: false },
      genresGroup: { type: Object, required: true, default: {} },
      genreCategories: { type: Object, required: true, default: {} },
      urls: { type: Object, required: true, default: {} },
      selected: { type: Array, required: true, default: {} },
      isClear: { type: Boolean, required: true, default: false },
    },
    emits: ['closeDialogSelectGenre', 'setListGenre'],
    data() {
      return {
        dialog: false,
        loading: false,
        categorySelect: '1,2',
        genres: [],
        category: {},
        tmpSelected: [],
        checkAll: false,
        array: [],
        quantityHint: 0,
        textGenreSelected: {},
        genresSelected: [],
        listGenreIdOfCategory: [],
        selectedDup: {},
        selectedGenres: {},
      };
    },
    methods: {
      handleClose() {
        const isSelectedDup = Object.keys(this.selectedDup).length;
        const isSelectedGenres = Object.keys(this.selectedGenres).length;
        const isSelected = Object.keys(this.selected).length;
        if ([isSelectedGenres, isSelected].every(e => e === 0)) {
          Object.keys(this.selectedDup).forEach((f) => {
               this.selectedGenres[f] = this.selectedDup[f]
               this.selected[f] = this.selectedDup[f]
            });
        } else if (isSelectedDup>0) {
          Object.keys(this.selectedGenres).forEach((e, i) => {
            Object.keys(this.selectedDup).forEach((f) => {
              if (e === f) {
                this.selectedGenres[e] = this.selectedDup[f]
              }
            });
          });
        }

        this.$emit('closeDialogSelectGenre')
      },

      selectCategory(index) {
        this.categorySelect = this.genreCategories[index].id;
        this.category = this.genreCategories[index];
        this.tmpSelected = this.selectedGenres[this.category.name];
        this.genres = this.genresGroup[this.category.name]
        this.isSelectedAll();
      },

      handleSelect(value) {
        this.selectedGenres[this.category.name] = this.tmpSelected;
        this.isSelectedAll();
        this.countFromGenre();
        this.setTextGenreSelected();
      },

      handleCheckAll(value) {
        this.tmpSelected = [];
        if (value) {
          this.genres.forEach(item => {
            this.tmpSelected.push(item.id);
          });
          this.textGenreSelected[this.category.name] = this.$t('all');
        } else {
          this.textGenreSelected[this.category.name] = '';
        }

        this.selectedGenres[this.category.name] = this.tmpSelected;

        this.countFromGenre();
      },

      checkGenreIsCurrentCategory(id) {
        this.genres.forEach(item => {
          if (item.id == id) {
            return true;
          }
        });

        return false;
      },

      isSelectedAll() {
        this.checkAll = (this.selectedGenres[this.category.name] != null && (this.selectedGenres[this.category.name].length == this.genres.length));
      },

      search() {
        Object.keys(this.selectedGenres).forEach((e, i) => {
          this.selected[e] = this.selectedGenres[e];
          let obj = this.selectedGenres[e];
          if (obj === undefined || obj.length == 0) {
            delete this.selectedGenres[e];
            delete this.selected[e];
          }
        });
        this.selectedDup = {...this.selectedGenres};
        this.$emit('setListGenre', this.selectedGenres);
      },

      clear() {
        this.checkAll = false;
        this.tmpSelected = [];
        this.quantityHint = 0;
        this.textGenreSelected = [];
        Object.keys(this.selectedGenres).forEach((e, i) => {
          delete this.selectedGenres[e];
          delete this.selected[e];
        });
      },

      getListSelectedGenreId() {
        let genreIds = [];
        Object.keys(this.selectedGenres).forEach(key => {
          genreIds = genreIds.concat([this.selectedGenres[key]])
        });

        return genreIds;
      },

      countFromGenre() {
        const genreIds = this.getListSelectedGenreId();

        if (genreIds.length == 0) {
          this.quantityHint = 0;
          return;
        }

        countFromGenre({genre_ids: genreIds}, this.urls.count_from_genre)
        .then(response => response.json())
        .then(response => {
          this.quantityHint = response.data;
        })
        .catch((error) => {})
      },

      setTextGenreSelected() {
        if (!this.tmpSelected) {
          return;
        }
        const listGenreName = [];
        this.tmpSelected.forEach(item => {
          const genre = this.genres.find(element => {
            return element.id == item;
          })
          listGenreName.push(genre.name);
        });
        this.textGenreSelected[this.category.name] = this.checkAll ? this.$t('all') : listGenreName.join("・");
      },

      getTextGenreSelected(arrSelected, ex, arrGenreSelected) {
        let result = "";
        for (let i in arrGenreSelected) {
          if (i === ex) {
            if (arrGenreSelected[i].length == Object.values(arrSelected).length) {
              return this.$t('all');
            }
            result = arrGenreSelected[i].filter(x => {
              return Object.values(arrSelected).includes(x.id);
            }).map(y => y.name).join("・");
          }
        }
        return result;
      },
    },

    created() {
      this.dialog = this.openDialogSelectGenre;
      this.tmpSelected = this.genreCategories;
      Object.keys(this.selected).forEach((e, i) => {
        let text = this.getTextGenreSelected(this.selected[e], e, this.genresGroup);
        this.textGenreSelected[e] =  text;
      });
      this.selectedGenres = {...this.selected};
      this.selectedDup = {...this.selectedGenres};

      this.isClear ? this.clear() : '';
      this.selectCategory(0, this.categorySelect);
      this.countFromGenre();
    },
  }
</script>

<style lang="scss">
  .form-genre {
    text-align: left !important;
    .el-dialog {
      width: 760px;
      height: 689px;
    }
    .title {
      text-align: center;
      font: normal normal normal 17px/37px Kozuka Gothic Pr6N;
      letter-spacing: 1.7px;
      color: #000000;
      font-weight: 700;
      margin-bottom: 30px;
      .note {
        font: normal normal normal 11px/24px Kozuka Gothic Pr6N;
        letter-spacing: 0.88px;
        color: #969696;
      }
    }
    .sidebar {
      padding-left: 30px;
      width: 180px;
      .region {
        height: 40px;
        background: #F7F3ED 0% 0% no-repeat padding-box;
        border: 1px solid #E9E5DF;
        border-bottom: 0px;
        font: normal normal normal 12px/26px Kozuka Gothic Pr6N;
        letter-spacing: 0.96px;
        color: #000000;
        cursor: pointer;
        .selected {
          background: #FFFFFF 0% 0% no-repeat padding-box;
        }
        .tab {
          width: 8px;
          height: 40px;
          background: #B0893C 0% 0% no-repeat padding-box;
        }
        .label-selected {
          padding: 7px 0 0 20px;
        }
        .label {
          padding: 7px 0 0 28px;
        }
      }
      .border-bottom {
        border: 1px solid #E9E5DF;
      }
    }
    .prefecture {
      background: #FFFFFF 0% 0% no-repeat padding-box;
      border: 1px solid #E9E5DF;
      margin-left: 20px;
      width: calc(100% - 266px);
      .select-all {
        height: 40px;
        border-bottom: 1px solid #E9E5DF;
        padding: 7px 0 0 23px;
      }
      .prefecture-item {
        padding: 25px;
      }
      .el-checkbox {
        font: normal normal normal 11px/24px Kozuka Gothic Pr6N;
        letter-spacing: 1.1px;
        color: #000000;
        --el-checkbox-font-size: 11px;
      }
    }

    .list-selected {
      margin-left: 30px;
      margin-top: 30px;
      padding: 10px 0px 0 20px;
      width: 88%;
      height: 90px;
      overflow-y: auto;
      background: #FFFFFF 0% 0% no-repeat padding-box;
      border: 1px solid #DDD8D1;
      font: normal normal normal 12px/26px Kozuka Gothic Pr6N;
      letter-spacing: 0.96px;
      color: #000000;
    }

    .hint {
      text-align: center;
      margin-top: 30px;
      .label {
        font: normal normal normal 11px/24px Kozuka Gothic Pr6N;
        letter-spacing: 0.88px;
        color: #505050;
      }
      .result {
        font: normal normal bold 20px/17px Futura;
        letter-spacing: 0.2px;
        color: #B0893C;
      }
      .ken {
        font: normal normal bold 13px/17px Futura;
        letter-spacing: 0.13px;
        color: #B0893C;
      }
    }

    .footer {
      margin-top: 30px;
      padding-left: 32%;
      .btn-search {
        background: #AC3B29 0% 0% no-repeat padding-box;
        --el-button-hover-bg-color: #AC3B29;
        --el-button-hover-border-color: #AC3B29;
        --el-button-border-color: #AC3B29;
        font: normal normal normal 13px/29px Kozuka Gothic Pr6N;
        letter-spacing: 1.3px;
        color: #FFFFFF;
        width: 250px;
        height: 50px !important;
        border-radius: 25px !important;
      }
      .btn-clear-select {
        width: 98px;
        height: 25px;
        box-shadow: 0px 1px 2px #00000029;
        border: 1px solid #E5E5E5;
        font: normal normal normal 12px/26px Kozuka Gothic Pr6N;
        letter-spacing: 1.2px;
        --el-button-text-color: #868686;
        --el-button-bg-color: #FDFDFD;
        --el-button-hover-bg-color: #FDFDFD;
        --el-button-hover-text-color: #868686;
        --el-button-active-bg-color: #FDFDFD;;
      }
    }

    .el-checkbox {
      --el-checkbox-checked-bg-color: #AC3B29;
      --el-checkbox-input-border-color-hover: #AC3B29;
      --el-checkbox-checked-icon-color: #FFFF;
      --el-checkbox-checked-input-border-color: #AC3B29;
      --el-checkbox-checked-text-color: #000000;
    }
  }
</style>
